import PropTypes from 'prop-types';

import { DynamicAsset } from '@/molecules/Media/index';
import RichText from '@/molecules/RichText/RichText';

import { CtfAssetPositions } from '@/utils/constants';
import { isWHEnv } from '@/utils/helper';
import Text from '@/atoms/Text/Text';

function StoryRecipeSteps({ assets = [], entries = [], fields = {} }) {
  const {
    id,
    title,
    text,
    callToAction,
    superText,
    headingWeight,
    dynamicAsset,
    fullWidth,
    hasBackground,
    hideText,
    hideHeader,
    cloudinaryAssets,
    mobileCloudinaryAsset,
    removeYPadding,
  } = fields;
  const HeadingTag = "h5";
  const assetPosition = CtfAssetPositions.LEFT;

  const mobileAsset = mobileCloudinaryAsset ?? cloudinaryAssets;
  return (
    <div className={`aaco-story-recipe-steps ${!removeYPadding && 'mb-20 dd-kr:mb-10 dd-en:mb-10 md:dd-kr:mb-[60px] md:dd-en:mb-[60px]'}`}
      id={id || title.toLowerCase().replace(' ', '-')}
    >
      <div
        className={`flex flex-col dd-kr:md:flex-row dd-en:flex-row mx-auto dd-en:container dd-kr:container gap-y-6 dd-kr:md:gap-y-0 dd-en:md:gap-y-0`}
      >
        {(mobileAsset || dynamicAsset) && (
          <div
            className={`w-full aaco-recipe-image h-[418px] aaco-story__image mb-8 md:mb-0 md:w-1/2 md:hidden ${
              assetPosition === CtfAssetPositions.LEFT
                ? 'md:order-1'
                : 'md:order-3'
            }`}
          >
            <DynamicAsset
              callToAction={callToAction}
              field={mobileAsset ?? dynamicAsset}
              assets={assets}
              entries={entries}
              container={'half-container'}
            />
          </div>
        )}
        {(cloudinaryAssets || dynamicAsset) && (
          <div
            className={`w-full aaco-recipe-image h-[476px] aaco-story__image mb-8 md:mb-0 hidden md:block ${
              assetPosition === CtfAssetPositions.LEFT
                ? 'md:order-1'
                : 'md:order-3'
            }`}
          >
            <DynamicAsset
              callToAction={callToAction}
              field={cloudinaryAssets ?? dynamicAsset}
              assets={assets}
              entries={entries}
              container={"half-container"}
            />
          </div>
        )}
        <div
          className={`aaco-story__content min-h-full order-2 w-full md:dd-kr:pl-[40px] md:dd-en:pl-[40px] dd-kr:pb-0 dd-en:pb-0 ${isWHEnv() ? 'w-auto p-0 md:pl-0 md:pr-0' : ''}`}
        >
          {title && !hideHeader && (
            <>
              {superText && (<Text tag="tag" style="text-black">{superText}</Text>)}
              <HeadingTag
                className={` dd-kr:mb-6 dd-en:mb-6 font-heading font-h5 text-h5 text-black`}
              >
                {title}
              </HeadingTag>
          {isWHEnv() && <hr className="border-black mt-3 mb-4" />}
            </>
          )}
          <div className="aaco-story-recipe-steps">
            {text?.content?.length > 0 &&
              text.content.map(({ content, nodeType }, index) => {
                return (
                  <RichText
                    entries={entries}
                    content={content}
                    key={index}
                    nodeType={nodeType}
                    richTextStyle={{
                      paragraph: {
                        customFont: 'font-text font-body text-body text-dark-warm-grey',
                        paragraphWrapper: 'py-3 dd-kr:py-0 dd-en:py-0',
                      },
                      list: {
                        ol: 'text-black',
                        li: 'pl-4 mb-7 last:mb-0 text-black',
                      },
                    }}
                  />
                );
              })}
          </div>
        </div>
      </div>
    </div>
  );
}

StoryRecipeSteps.propTypes = {
  assets: PropTypes.array,
  entries: PropTypes.array,
  fields: PropTypes.object,
  hideHeader: PropTypes.bool,
};

export default StoryRecipeSteps;
